module.exports = __webpack_public_path__ + "static/media/avatar.3d5adcb8.png";